import React from "react";
import {useState, useRef} from "react";
import Props from "../../models/Properties"
import {Form, Row, Col } from 'react-bootstrap';

const InputFloat4: React.FC<{data: any}> = (props) => {
    const [value, setValue] = useState(Props.currentValue(props.data.prop));
    const refs = [useRef<HTMLInputElement>(null),
                  useRef<HTMLInputElement>(null),
                  useRef<HTMLInputElement>(null),
                  useRef<HTMLInputElement>(null)];

    function changeHandler() {
        let v = [+refs[0].current!.value,
                 +refs[1].current!.value,
                 +refs[2].current!.value,
                 +refs[3].current!.value];
        setValue(v);
        props.data.onChange(props.data.prop, v);
    }
    return (
        <>
            <Form.Label>{props.data.prop.title}</Form.Label>
            <Row>
                <Col>
                    <Form.Control type="number" ref={refs[0]} value={value[0]} onChange={changeHandler} readOnly={props.data.prop.readOnly} />
                </Col>
                <Col>
                    <Form.Control type="number" ref={refs[1]} value={value[1]} onChange={changeHandler} readOnly={props.data.prop.readOnly} />
                </Col>
                <Col>
                    <Form.Control type="number" ref={refs[2]} value={value[2]} onChange={changeHandler} readOnly={props.data.prop.readOnly} />
                </Col>
                <Col>
                    <Form.Control type="number" ref={refs[3]} value={value[3]} onChange={changeHandler} readOnly={props.data.prop.readOnly} />
                </Col>
            </Row>
        </>
    );
};

export default InputFloat4;
